import type { ProjectResponseUserInfoBasicInfo } from './projectResponseUserInfoBasicInfo';
import type { ProjectResponseUserInfoSocial } from './projectResponseUserInfoSocial';

/**
 * 간략한 사용자 정보
 */
export type ProjectResponseUserInfo = {
  /** 사용자 기본 정보 */
  basicInfo: ProjectResponseUserInfoBasicInfo;
  /** 소셜 관계 정보 */
  social?: ProjectResponseUserInfoSocial;
};
